import React from "react";
import Header from "../components/Header";

import "../assets/styles/components/About.css";

// Agregar
const About = () => {
  return (
    <div>
      <Header />

      <div className="about-container">
        {/*  */}
        {/* section the title */}
        <div className="about-title-section">
          <h2>YOLO VIDEOS </h2>
        </div>

        {/* descripcion */}
        <div className="about-description-section">
          <p>
            It is MoonMakers video, it is a Web platform that is made with the
            MERN stack:
          </p>

          <ul>
            <li>The Frontend with React.js</li>
            <li>The Backend with Node.js and Express.js</li>
            <li>The Data bashe with moongoDB</li>
            <img
              src="https://www.gifmania.com/Gif-Animados-Deportes/Imagenes-Artes-Marciales/Taekwondo/Ko-Taekwondo-85496.gif"
              alt=""
            />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
